import { create } from 'zustand';

const useSnackbarStore = create((set) => ({
  snackbar: {
    open: false,
    message: '',
    severity: 'success', // success, error, warnings
  },

  // Function to set snackbar state
  setSnackbar: (message, severity = 'success') => {
    set({ snackbar: { open: true, message, severity } });
  },

  // Function to close snackbar
  closeSnackbar: () => {
    set({ snackbar: { open: false, message: '', severity: 'success' } });
  },
}));

export default useSnackbarStore;
